import { IconButton, Tooltip, useClipboard } from "@chakra-ui/react";
import { FaCheck, FaRegCopy } from "react-icons/fa";

type Props = {
  value: string;
  // Nome do que é copiado, pro aria-label e o tooltip ("Copiar CPF").
  rotulo: string;
};

// Botão de copiar do cabeçalho da CCB (TAR-ADM-cobranca-086). Fica dentro da
// área clicável que expande a linha — o stopPropagation impede que copiar
// também abra/feche o detalhe.
export default function CopyButton({ value, rotulo }: Props) {
  const { hasCopied, onCopy } = useClipboard(value);

  return (
    <Tooltip label={hasCopied ? "Copiado!" : `Copiar ${rotulo}`} placement="top" hasArrow>
      <IconButton
        aria-label={`Copiar ${rotulo}`}
        icon={hasCopied ? <FaCheck /> : <FaRegCopy />}
        size="xs"
        variant="ghost"
        color={hasCopied ? "green.500" : "gray.400"}
        alignSelf="center"
        onClick={(e) => {
          e.stopPropagation();
          onCopy();
        }}
      />
    </Tooltip>
  );
}
